import { AppHeaderProps } from "./types";
import { Icon, checkEmpty, Typography, toast } from "top-brains-ui";
import "./AppHeader.scss";
import classNames from "classnames";
import HeaderMenuDropdown from "../header-menu-dropdown/HeaderMenuDropdown";
import { optionsType } from "../header-menu-dropdown/types";
import { truncateText } from "@src/utils/CommonUtils";
import React from "react";
import { STUDENT_BATCH_CONSTANTS } from "@src/constants/UiConstants";

const AppHeader: React.FC<AppHeaderProps> = ({
  logoIconName = "",
  width,
  borderRadius,
  leftContent,
  rightContent,
  appHeaderMenuItems,
  selectedMenu,
  selectedSubMenu,
  onMenuClick = () => {},
  onSubMenuClick = () => {},
  onMenuDropdownClick = () => {},
  onMenuDropdownLabelClick = () => {},
}) => {
  const menuDropdownLabelClickHandler = (name: string) => {
    onMenuDropdownLabelClick(name);
  };
  return (
    <div className="app-header-main">
      <div
        className="app-header"
        style={{
          borderStartStartRadius: borderRadius,
          borderStartEndRadius: borderRadius,
        }}
      >
        <div className="app-header-left-container">
          <div className="app-header-logo-icon">
            <Icon color="" name={logoIconName} height={25} width={60} />
          </div>
          {leftContent && (
            <div className="app-header-left-content">{leftContent}</div>
          )}
        </div>
        {!checkEmpty(appHeaderMenuItems) && (
          <div className="app-header-nav-bar" style={{ width: width }}>
            {/* {menuDropdownList && !checkEmpty(menuDropdownList) && (
              <div>
                {
                  <HeaderMenuDropdown
                    onMenuClick={() => setDropdownMenuSelected(true)}
                    selected={dropdownMenuSelected}
                    options={menuDropdownList}
                    selectedOption={selectedProject}
                    menuDropdownLabelClick={onMenuDropdownLabelClick}
                    onSubMenuClick={onSubMenuClick}
                    subMenuList={dropdownSubMenuItems}
                    selectedSubMenu={selectedSubMenu}
                    placeholder="Search"
                  />
                }
              </div>
            )} */}
            <div className="app-header-nav-bar-items fontSm">
              {appHeaderMenuItems.map((menuItem, index) => {
                const isMenuSelected =
                  Boolean(selectedMenu) &&
                  (menuItem?.name?.toLowerCase() ===
                    selectedMenu?.toLowerCase() ||
                    (typeof menuItem?.label === "string" &&
                      menuItem?.label?.toLowerCase() ===
                        selectedMenu?.toLowerCase()));

                const isSubMenuSelected = (subLabel?: string) =>
                  Boolean(selectedSubMenu) &&
                  subLabel?.toLowerCase() === selectedSubMenu?.toLowerCase();

                return (
                  !menuItem?.hide &&
                  (menuItem?.type === "dropdown" ? (
                    <React.Fragment key={`menu-item-${index}`}>
                      {menuItem?.list && !checkEmpty(menuItem?.list) && (
                        <div>
                          {
                            <HeaderMenuDropdown
                              menuDropdownLabelClick={() =>
                                menuDropdownLabelClickHandler(menuItem?.name)
                              }
                              selected={isMenuSelected}
                              options={menuItem?.list}
                              selectedOption={
                                menuItem?.selectedDropdownItem
                                  ? menuItem?.selectedDropdownItem
                                  : menuItem?.list?.[0]
                              }
                              menuDropdownOptionClick={(
                                option: optionsType,
                              ) => {
                                if (
                                  (option as any)?.batchType === "SELF_PACED"
                                ) {
                                  toast.error(
                                    "Error",
                                    STUDENT_BATCH_CONSTANTS.BATCH_ACCESSIBLE_ONLY_IN_ELP_APP,
                                  );
                                  return;
                                }
                                onMenuDropdownClick(menuItem?.name, option);
                              }}
                              onSubMenuClick={onSubMenuClick}
                              subMenuList={
                                isMenuSelected &&
                                (Boolean(selectedSubMenu) ||
                                  (Boolean(
                                    menuItem?.selectedDropdownItem?.label,
                                  ) &&
                                    menuItem?.selectedDropdownItem?.label !==
                                      menuItem?.defaultDropdownLabel))
                                  ? menuItem?.subMenuItems
                                  : []
                              }
                              selectedSubMenu={selectedSubMenu}
                              placeholder="Search"
                              loadMore={menuItem?.loadMore}
                              hasMore={menuItem?.hasMore}
                              isLoading={menuItem?.isLoading}
                            />
                          }
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                    <div
                      className={classNames("app-header-nav-bar-item", {
                        ["app-header-nav-bar-item--selected"]: isMenuSelected,
                      })}
                      key={menuItem?.label}
                    >
                      <Typography
                        as="div"
                        className="app-header-nav-bar-item-label"
                        lineHeight="18px"
                        onClick={() => {
                          onMenuClick(menuItem);
                        }}
                      >
                        {truncateText(menuItem?.label as string, 25)}
                      </Typography>
                      {isMenuSelected &&
                        menuItem?.subMenuItems && (
                          <>
                            {menuItem?.subMenuItems?.map((subMenuItem, index) => {
                              return (
                                <React.Fragment key={`submenu-item-${index}`}>
                                  {!subMenuItem?.hide && (
                                    <div
                                      key={subMenuItem?.label}
                                      className="app-header-submenu-container"
                                    >
                                      <Typography
                                        as="div"
                                        className={classNames(
                                          "app-header-submenu-item",
                                          {
                                            ["app-header-submenu-item--selected"]:
                                              isSubMenuSelected(
                                                subMenuItem?.label,
                                              ),
                                          },
                                        )}
                                        lineHeight="18px"
                                        onClick={() =>
                                          onSubMenuClick(subMenuItem)
                                        }
                                      >
                                        {subMenuItem?.label}
                                      </Typography>
                                    </div>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </>
                        )}
                    </div>
                  ))
                );
              })}
            </div>
          </div>
        )}
        {rightContent && (
          <div className="app-header-right-content">{rightContent}</div>
        )}
      </div>
    </div>
  );
};
export default AppHeader;
